import { IBehavior, IBehaviorParams, ITableRes } from 'types'
import { baseApi } from './baseApi'

export const behaviorAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_behavior: builder.query<ITableRes<IBehavior>, IBehaviorParams>({
      query: (params) => ({
        url: '/behaviour-incidents/',
        params: params
      }),
      providesTags: ['behavior'],
    }),
    GET_behaviorById: builder.query<ITableRes<IBehavior>, number>({
      query: (id) => {
        return {
          url: `/behaviour-incidents/${id}/`,
        }
      },
      providesTags: ['behavior'],
    }),
    POST_behavior: builder.mutation<any, any>({
      query: (body) => ({
        url: `/behaviour-incidents/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['behavior'],
    }),
    PATCH_behavior: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/behaviour-incidents/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['behavior'],
    }),
    DELETE_behavior: builder.mutation<any, number>({
      query: (id) => ({
        url: `/behaviour-incidents/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['behavior'],
    }),
  }),
})

export const {
  useGET_behaviorQuery,
  useGET_behaviorByIdQuery,
  usePOST_behaviorMutation,
  usePATCH_behaviorMutation,
  useDELETE_behaviorMutation,
} = behaviorAPI
